module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_retail_sp-22205a5c249ad558f55d8268bee611a0.svg";